/*
  Project: Boilerplate
  Author: i3 Digital
 */

window.jQuery = window.$ = require('jquery');
require('./jquery-ui');

/* Vendor */

require('slick-carousel');
require('jquery.mmenu');
require('./vendor/jquery-stickit');
require('./vendor/scrollspy');
require('./vendor/jquery-lazy');
require('./vendor/jquery.sticky');

/* Custom Scripts */

require('./custom/accessible-slider');
require('./custom/accordion');
require('./custom/slick-slider');
require('./custom/mobile-search');
/*require('./custom/mmenu');*/
require('./custom/share-btn');
require('./custom/scroll-top');
require('./custom/quick-nav');
require('./custom/filter-results');
require('./custom/language-select');
require('./custom/lazy-load');
require('./custom/megamenu');
require('./custom/banner-pods');
require('./custom/footer-menu');
require('./custom/sidebar-nav');
require('./custom/sidebar-nav-mobile');
require('./custom/disciplinary-search');
require('./custom/date-picker');
require('./custom/ada-menu');
require('./custom/references');
require('./custom/sticky');
require('./custom/scrollspy--init');
